// removed by extract-text-webpack-plugin
module.exports = {"formLabel":"formLabel___1Dejf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HookFormInputs/FormError.module.less
// module id = 3712
// module chunks = 30